<template>
  <div class="recent-section">
    <h3 class="section-title">Recent Pages</h3>
    <div class="recent-list">
      <router-link 
        v-for="page in visibleRecentPages" 
        :key="page.path"
        :to="page.path" 
        class="nav-item recent-item" 
        active-class="active"
      >
        <span class="recent-icon" v-html="getIconSvg(page.icon)"></span>
        <span class="recent-title">{{ page.title }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getIconSvg } from '@/utils/icons';

export default {
  name: 'RecentPagesSection',
  props: {
    recentPages: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 3
    }
  },
  computed: {
    visibleRecentPages() {
      return this.recentPages.slice(0, this.limit);
    }
  },
  methods: {
    getIconSvg
  }
}
</script>

<style scoped>
.recent-section {
  margin-bottom: 2rem;
}

.section-title {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: white;
  margin-bottom: 1rem;
  font-weight: 600;
  padding-left: 1rem;
}

.recent-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 0.7rem 1rem;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.25s ease;
  position: relative;
  overflow: hidden;
  font-weight: 500;
  font-size: 0.9rem;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.06);
  color: white;
}

.recent-icon {
  margin-right: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.recent-icon svg {
  width: 16px;
  height: 16px;
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.25s ease;
}

.nav-item:hover .recent-icon svg {
  color: white;
}

.nav-item.active {
  background: rgba(79, 70, 229, 0.15);
  color: white;
  font-weight: 600;
}

.nav-item.active .recent-icon svg {
  color: #4f46e5;
}

/* Light theme overrides */
:root[data-theme="light"] .section-title {
  color: #1f2937;
}

:root[data-theme="light"] .nav-item {
  color: rgba(0, 0, 0, 0.7);
}

:root[data-theme="light"] .recent-icon svg {
  color: rgba(0, 0, 0, 0.5);
}

:root[data-theme="light"] .nav-item:hover {
  background: rgba(0, 0, 0, 0.04);
  color: #000;
}

:root[data-theme="light"] .nav-item:hover .recent-icon svg {
  color: #000;
}

:root[data-theme="light"] .nav-item.active {
  background: rgba(79, 70, 229, 0.1);
  color: #4f46e5;
}
</style> 